import SkeletonButton from "antd/es/skeleton/Button";
import { useMemo } from "react";
import { Flex } from "../Flex/Flex";
import { SkeletonInput } from "../Skeleton/AntSkeleton";

interface CheckBoxLoaderProps {
  rows?: number;
}
function CheckBoxLoader(props: CheckBoxLoaderProps) {
  const { rows = 4 } = props;

  function getRows() {
    return Array.from({ length: rows }, (value) => {
      return { value: String(value) };
    });
  }

  const length = useMemo(getRows, [rows]);
  const Box = (
    <SkeletonButton
      active
      style={{ width: "16px", height: "16px" }}
      size="small"
    />
  );
  const Text = <SkeletonInput active size="small" style={{ height: "16px" }} />;
  return (
    <Flex vertical>
      {length.map((f) => {
        return (
          <Flex align="center" key={f.value}>
            {Box}
            {Text}
          </Flex>
        );
      })}
    </Flex>
  );
}

export { CheckBoxLoader };
